// Auto-generated API paths
// Do not edit manually - regenerate using generate-api-types.sh
// Eureka (FE-5): mod-br-users endpoints moved under the br-users namespace
// (/br-users/users*, /br-users/_self, /br-users/select-organization, /br-users/inbox);
// /organizations, /audit-logs and /admin/* are unchanged. Login/forgotten-password/
// password-reset entries stay on platform paths (OIDC rework owns them). Reconciled
// manually against mod-br-users!141 ModuleDescriptor — regenerate once it merges.
export var API_PATHS = {
    /**
     * Path: /br-users/users
     * GET: Retrieve a list of user items.
     * Response: userDtoCollection
     * POST: Create a new user.
     * Request: UserCreateDto
     * Response: UserDto
     */
    USERS: 'br-users/users',
    /**
     * Path: /br-users/users/change-current-password
     * POST: Changes the password for the currently authenticated user.
     * Request: ChangeCurrentPasswordDto
     * Response: void
     */
    USERS_CHANGE_CURRENT_PASSWORD: 'br-users/users/change-current-password',
    /**
     * Path: /bl-users/forgotten/password
     * POST: Generates and sends a password reset token via email for an anonymous user.
     * Request: RequestPasswordResetDto
     * Response: void
     */
    BL_USERS_FORGOTTEN_PASSWORD: 'bl-users/forgotten/password',
    /**
     * Path: /users/password-reset
     * POST: Resets the user's password using a provided token.
     * Request: ResetPasswordWithTokenDto
     * Response: void
     */
    USERS_PASSWORD_RESET: 'users/password-reset',
    /**
     * Path: /user-tenants
     * GET: No description
     * Response: userTenantsDtoCollection
     */
    USER_TENANTS: 'user-tenants',
    /**
     * Path: /perms/permissions
     * GET: No description
     * Response: permissionsDtoCollection
     */
    PERMS_PERMISSIONS: 'perms/permissions',
    /**
     * Path: /authn/login
     * POST: Authenticate user and get a login token (Legacy endpoint)
     * Response: loginToken
     */
    AUTHN_LOGIN: 'authn/login',
    /**
     * Path: /authn/refresh
     * POST: Get a new refresh and access token for logged user
     * Response: TokenExpiration
     */
    AUTHN_REFRESH: 'authn/refresh',
    /**
     * Path: /authn/logout
     * POST: Logs the user out on their current device
     * Response: void
     */
    AUTHN_LOGOUT: 'authn/logout',
    /**
     * Path: /bl-users/login-with-expiry
     * POST: Authenticate user and get composed response with user and token info
     * Response: loginWithUserDto
     */
    BL_USERS_LOGIN_WITH_EXPIRY: 'bl-users/login-with-expiry',
    /**
     * Path: /br-users/select-organization
     * POST: Select active organization of a logged in user
     * Response: loginWithUserDto
     */
    BR_USERS_SELECT_ORGANIZATION: 'br-users/select-organization',
    /**
     * Path: /br-users/_self
     * GET: No description
     * Response: loginWithUserDto
     * PUT: Update logged user
     * Request: UserPersonal
     * Response: void
     */
    BR_USERS_SELF: 'br-users/_self',
    /**
     * Path: /organizations
     * GET: Retrieve a list of organization items.
     * Response: organizationDtoCollection
     * POST: Create a new organization.
     * Response: OrganizationDto
     */
    ORGANIZATIONS: 'organizations',
    /**
     * Path: /br-users/inbox
     * POST: Process an event in the inbox
     * Request: InboxEventDto
     * Response: string
     */
    USERS_INBOX: 'br-users/inbox',
    /**
     * Path: /audit-logs
     * GET: Retrieve a list of audit logs.
     * Response: auditLogDtoCollection
     */
    AUDIT_LOGS: 'audit-logs',
    /**
     * Path: /br-users/users/my-profile
     * GET: Retrieve user's personal information
     * Response: UserDto
     * PUT: Update user's personal information
     * Request: UserDto
     * Response: void
     */
    USERS_MY_PROFILE: 'br-users/users/my-profile',
    /**
     * Path: /br-users/users/my-organizations-count
     * GET: Get the count of organizations for the current user
     * Response: OrganizationCount
     */
    USERS_MY_ORGANIZATIONS_COUNT: 'br-users/users/my-organizations-count',
    /**
     * Path: /br-users/users/my-sources-count
     * GET: Get the count of sources for the current user
     * Response: UserSourceCount
     */
    USERS_MY_SOURCES_COUNT: 'br-users/users/my-sources-count',
    /**
     * Path: /br-users/users/keycloak-backfill
     * POST: Mirror BR users and their organization roles into Keycloak / mod-roles-keycloak (idempotent)
     * Response: KeycloakBackfillResultDto
     */
    USERS_KEYCLOAK_BACKFILL: 'br-users/users/keycloak-backfill',
    /**
     * Path: /admin/environment-variables-users
     * GET: Get environment variables
     * Response: environmentVariableDtoCollection
     */
    ADMIN_ENVIRONMENT_VARIABLES_USERS: 'admin/environment-variables-users',
    /**
     * Path: /admin/registration-email
     * GET: Recipient count and status of the initialization (complete-registration) email
     * POST: Start sending the initialization email to all users (409 while a run is in progress)
     * Response: RegistrationEmailStatusDto
     */
    ADMIN_REGISTRATION_EMAIL: 'admin/registration-email',
    /**
     * Path: /bl-users/password-reset/validate
     * POST: Validates the link for password reset
     * Response: void
     */
    BL_USERS_PASSWORD_RESET_VALIDATE: 'bl-users/password-reset/validate',
    /**
     * Path: /bl-users/password-reset/reset
     * POST: Resets the user's password using a provided token.
     * Request: ResetPasswordDto
     * Response: void
     */
    BL_USERS_PASSWORD_RESET_RESET: 'bl-users/password-reset/reset',
};
// Parameterized path functions
/**
 * Path: /br-users/users/{id}
 * GET: Retrieve user with given ID
 * Response: UserDto
 * PUT: Update user with given ID.
 * Request: UserDto
 * Response: void
 * DELETE: Delete user with given ID.
 * Response: void
 */
export var usersId = function (id) { return "br-users/users/".concat(id); };
/**
 * Path: /br-users/users/{id}/reset-password
 * POST: Allows an admin to reset another user's password
 * Request: ResetUserPasswordDto
 * Response: void
 */
export var usersIdResetPassword = function (id) { return "br-users/users/".concat(id, "/reset-password"); };
/**
 * Path: /br-users/users/{userId}/organizations
 * GET: Retrieve a list of organizations user belongs to with permitted roles.
 * Response: userOrganizationsDtoCollection
 */
export var usersUseridOrganizations = function (userId) { return "br-users/users/".concat(userId, "/organizations"); };
/**
 * Path: /br-users/users/{userId}/organizations/{orgId}
 * PUT: Set user's belonging to an organization with specified permitted roles
 * Request: RolesSet
 * Response: void
 * DELETE: Delete user's belonging to an organization
 * Response: void
 */
export var usersUseridOrganizationsOrgid = function (userId, orgId) { return "br-users/users/".concat(userId, "/organizations/").concat(orgId); };
/**
 * Path: /br-users/users/{userId}/organizations/{orgId}/archive
 * POST: Archive user's belonging to an organization
 * Response: void
 */
export var usersUseridOrganizationsOrgidArchive = function (userId, orgId) { return "br-users/users/".concat(userId, "/organizations/").concat(orgId, "/archive"); };
/**
 * Path: /br-users/users/{userId}/organizations/{orgId}/restore
 * POST: Restore user's belonging to an organization
 * Response: void
 */
export var usersUseridOrganizationsOrgidRestore = function (userId, orgId) { return "br-users/users/".concat(userId, "/organizations/").concat(orgId, "/restore"); };
/**
 * Path: /perms/users/{id}/permissions
 * GET: Get permissions for a user
 * Response: userPermissionsDtoCollection
 */
export var permsUsersIdPermissions = function (id) { return "perms/users/".concat(id, "/permissions"); };
/**
 * Path: /organizations/{id}
 * GET: Retrieve organization with given ID
 * Response: OrganizationDto
 * PUT: Update organization with given ID.
 * Response: void
 * DELETE: Delete organization with given ID.
 * Response: void
 */
export var organizationsId = function (id) { return "organizations/".concat(id); };
/**
 * Path: /organizations/{id}/archive
 * POST: Archive organization
 * Response: void
 */
export var organizationsIdArchive = function (id) { return "organizations/".concat(id, "/archive"); };
/**
 * Path: /organizations/{id}/restore
 * POST: Restore organization
 * Response: void
 */
export var organizationsIdRestore = function (id) { return "organizations/".concat(id, "/restore"); };
/**
 * Path: /br-users/users/{id}/organizations-count
 * GET: Get the count of organizations for a user
 * Response: OrganizationCount
 */
export var usersIdOrganizationsCount = function (id) { return "br-users/users/".concat(id, "/organizations-count"); };
/**
 * Path: /br-users/users/{id}/sources-count
 * GET: Get the count of sources for a user
 * Response: UserSourceCount
 */
export var usersIdSourcesCount = function (id) { return "br-users/users/".concat(id, "/sources-count"); };
/**
 * Path: /audit-logs/{id}/previous
 * GET: Returns the audit log record preceding the given one for the same entity
 * Response: AuditLogDto (204 when there is none)
 */
export var auditLogsIdPrevious = function (id) { return "audit-logs/".concat(id, "/previous"); };
